(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-st-pdp]').forEach(pdp => {
      if (pdp.dataset.ready) return;
      pdp.dataset.ready = 'true';
      const slides = [...pdp.querySelectorAll('[data-st-media]')];
      const thumbs = [...pdp.querySelectorAll('[data-st-thumbnail]')];
      let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
      function show(index) {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== active;
          if (i !== active) slide.querySelectorAll('video').forEach(video => video.pause());
          if (i !== active) slide.querySelectorAll('iframe').forEach(frame => {
            // Remove the player while off-screen so external video cannot keep playing.
            if (!frame.dataset.playerSrc) frame.dataset.playerSrc = frame.src;
            frame.removeAttribute('src');
          });
          else slide.querySelectorAll('iframe[data-player-src]').forEach(frame => { if (!frame.getAttribute('src')) frame.src = frame.dataset.playerSrc; });
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
        const count = pdp.querySelector('[data-st-gallery-count]');
        if (count) count.textContent = `${active + 1} / ${slides.length}`;
      }
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      pdp.querySelector('[data-st-gallery-prev]')?.addEventListener('click', () => show(active - 1));
      pdp.querySelector('[data-st-gallery-next]')?.addEventListener('click', () => show(active + 1));
      const gallery = pdp.querySelector('[data-st-gallery]');
      gallery.addEventListener('keydown', event => {
        if (event.target.closest('video, iframe, model-viewer')) return;
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1));
      });
      let touch;
      gallery.addEventListener('touchstart', e => { touch = e.touches[0]; }, {passive:true});
      gallery.addEventListener('touchend', e => {
        if (!touch || e.target.closest('video, iframe, model-viewer')) return;
        const dx=e.changedTouches[0].clientX-touch.clientX, dy=e.changedTouches[0].clientY-touch.clientY;
        if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)) show(active+(dx<0?1:-1));
        touch=null;
      }, {passive:true});
      const dialog = pdp.querySelector('[data-st-lightbox]');
      pdp.querySelectorAll('[data-st-zoom]').forEach(link => link.addEventListener('click', event => {
        if (!dialog.showModal) return;
        event.preventDefault();
        dialog.querySelector('img').src = link.href;
        dialog.querySelector('img').alt = link.querySelector('img').alt;
        dialog.showModal();
      }));
      pdp.querySelector('[data-st-close-zoom]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      const form = pdp.querySelector('[data-st-pdp-form]');
      const select = form.querySelector('[data-st-pdp-variant]');
      const quantity = form.querySelector('[name="quantity"]');
      const submitButtons = [...form.querySelectorAll('[type="submit"]'),pdp.querySelector('[data-st-sticky-add]')];
      const status = form.querySelector('[data-st-pdp-status]');
      const choices = [...form.querySelectorAll('[data-st-variant-choice]')];
      if (choices.length) {
        form.querySelector('[data-st-pdp-options]').hidden = false;
        select.classList.add('visually-hidden');
        select.tabIndex = -1;
      }
      const optionFields = [...form.querySelectorAll('[data-st-option-index]')];
      const variantOptions = [...select.options];
      if (optionFields.length) {
        form.querySelector('[data-st-option-fields]').hidden = false;
        form.querySelector('[data-st-combined-label]')?.classList.add('visually-hidden');
        select.hidden = true;
        select.tabIndex = -1;
        optionFields.forEach(field => field.addEventListener('change', () => {
          if (form.dataset.busy || form.dataset.processing === 'true') return;
          const values = optionFields.map(input => input.value);
          const match = variantOptions.find(option => JSON.parse(option.dataset.options).every((value, index) => value === values[index]));
          select.value = match?.value || '';
          updateVariant();
        }));
      }
      function updateVariant(updateUrl = true) {
        const option = select.selectedOptions[0];
        if (!option) {
          submitButtons.forEach(button => { button.disabled = true; });
          pdp.querySelector('[data-st-pdp-stock]').textContent = 'Unavailable combination';
          pdp.querySelector('[data-st-add-label]').textContent = 'Unavailable';
          pdp.querySelector('[data-st-sticky-add]').textContent = 'Unavailable';
          pdp.querySelector('[data-st-pdp-price]').textContent = '';
          pdp.querySelector('[data-st-sticky-price]').textContent = '';
          pdp.querySelector('[data-st-pdp-compare]').hidden = true;
          pdp.querySelector('[data-st-sticky-variant]').textContent = optionFields.map(field => field.value).join(' / ');
          status.textContent = 'This combination is unavailable. Please choose another option.';
          const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url);
          return;
        }
        if (optionFields.length) {
          const values = JSON.parse(option.dataset.options);
          optionFields.forEach((field, index) => { field.value = values[index]; });
        }
        const available = option.dataset.available === 'true';
        pdp.querySelector('[data-st-pdp-price]').textContent = option.dataset.price;
        pdp.querySelector('[data-st-sticky-price]').textContent = option.dataset.price;
        pdp.querySelector('[data-st-sticky-variant]').textContent = option.dataset.title === 'Default Title' ? '' : ' · ' + option.dataset.title;
        const compare = pdp.querySelector('[data-st-pdp-compare]');
        compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true';
        pdp.querySelector('[data-st-pdp-stock]').textContent = available ? 'Ready for play' : 'Sold out';
        pdp.querySelector('[data-st-add-label]').textContent = available ? 'Add to cart' : 'Sold out';
        pdp.querySelector('[data-st-sticky-add]').textContent = available ? 'Add to cart +' : 'Sold out';
        submitButtons.forEach(button => { button.disabled = !available; });
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.stVariantChoice === option.value)));
        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const mediaIndex = slides.findIndex(slide => slide.dataset.stMedia === option.dataset.media);
        if (mediaIndex !== -1) show(mediaIndex);
        status.textContent = '';
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
      }
      choices.forEach(button => button.addEventListener('click', () => { select.value = button.dataset.stVariantChoice; updateVariant(); }));
      select.addEventListener('change', () => updateVariant());
      form.querySelectorAll('[data-st-quantity]').forEach(button => button.addEventListener('click', () => {
        if (button.dataset.stQuantity === '1') quantity.stepUp(); else quantity.stepDown();
      }));
      const linkedVariant = new URL(location.href).searchParams.get('variant');
      if (linkedVariant && [...select.options].some(option => option.value === linkedVariant)) select.value = linkedVariant;
      updateVariant(false);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.busy || select.selectedOptions[0]?.dataset.available !== 'true') return;
        form.dataset.busy = 'true'; form.setAttribute('aria-busy','true');
        submitButtons.forEach(button => { button.disabled = true; });
        choices.forEach(button => { button.disabled = true; }); select.disabled = true;
        optionFields.forEach(field => { field.disabled = true; });
        const buy = event.submitter?.dataset.intent === 'buy';
        status.textContent = 'Adding a little happy…';
        pdp.querySelector('[data-st-sticky-status]').textContent = status.textContent;
        try {
          const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[{id:Number(select.value),quantity:Number(quantity.value)}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add this toy. Please try again.');
          if (buy) { location.assign(form.dataset.checkoutUrl); return; }
          if (window.SashaktCart) await window.SashaktCart.open(event.submitter);
          status.textContent = 'Added to your bag! ';
          const link = document.createElement('a'); link.href = form.dataset.cartUrl; link.textContent = 'View bag →'; status.append(link);
          document.querySelectorAll('.st-header-actions a[aria-label="Shopping bag"]').forEach(link => { link.href = form.dataset.cartUrl; });
        } catch(error) { status.textContent = error.message || 'Please try again.'; }
        finally {
          pdp.querySelector('[data-st-sticky-status]').replaceChildren(...[...status.childNodes].map(node => node.cloneNode(true)));
          delete form.dataset.busy; form.removeAttribute('aria-busy'); select.disabled = false;
          choices.forEach(button => { button.disabled = false; });
          optionFields.forEach(field => { field.disabled = false; });
          submitButtons.forEach(button => { button.disabled = select.selectedOptions[0]?.dataset.available !== 'true'; });
        }
      });
      pdp.querySelector('[data-st-copy-code]')?.addEventListener('click', async event => {
        const button = event.currentTarget;
        const copyStatus = pdp.querySelector('[data-st-copy-status]');
        try { await navigator.clipboard.writeText(button.dataset.stCopyCode); button.querySelector('span').textContent = 'Copied!'; copyStatus.textContent = 'Offer code copied. Enter it at checkout.'; }
        catch { copyStatus.textContent = 'Copy this code: '+button.dataset.stCopyCode; button.querySelector('span').textContent = 'Select & copy'; }
      });
      const sticky=pdp.querySelector('[data-st-sticky]');
      if ('IntersectionObserver' in window) {
        const observer=new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0; });
        observer.observe(form);
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(pdp)) observer.disconnect(); }, {once:true});
      }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize()); else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
